export default class SchoolContact {
  schoolName = '';
  contactFirstName = '';
  contactLastName = '';
  phone = '';
  email = '';
}
